import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e62a86c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  ref: "configureSettings",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Configure Settings")
const _hoisted_5 = {
  class: "qs-tabs nav nav-tabs",
  role: "tablist"
}
const _hoisted_6 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "General", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Formatting", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Source Order", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Shared Settings", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "tab-content" }
const _hoisted_19 = ["checked"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Do not suggest changes to my Data Preferences")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = ["checked"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Save all property data to TOTAL on save regardless of viewed status")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Global Preferred Case:")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Global preferred casing will only be applied to the Transfer to Form field. Field specific case rules will take priority over this setting.")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Reorder the Data Source columns below.")
const _hoisted_27 = ["checked"]
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Display Data Preference Settings column")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Share My Settings", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fst-italic" }, "By enabling this setting, other users on your account can now use and alter your Data Preference, Formatting Rules and Casing as if you all share a single QuickSource account.", -1))
const _hoisted_31 = { class: "ms-3 mb-3" }
const _hoisted_32 = ["checked", "disabled"]
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Share my settings with others on this account")
const _hoisted_34 = {
  key: 0,
  class: "alert alert-warning"
}
const _hoisted_35 = ["ppid"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fst-italic" }, "I want to use the following person's settings.", -1))
const _hoisted_37 = { class: "ms-3" }
const _hoisted_38 = {
  id: "useUserSettings",
  class: "form-select w-50"
}
const _hoisted_39 = ["value", "selected"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-secondary",
  "data-bs-dismiss": "modal"
}, "Cancel", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_PreferredCasing = _resolveComponent("PreferredCasing")!
  const _component_SourceOrder = _resolveComponent("SourceOrder")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ModalHeader, null, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_ModalBody, null, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", [_ctx.isActiveTab(0)]]),
                  id: "general-tab",
                  "data-bs-toggle": "tab",
                  href: "#general",
                  role: "tab",
                  "aria-controls": "general",
                  "aria-selected": "true"
                }, _hoisted_8, 2)
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", [_ctx.isActiveTab(1)]]),
                  id: "formatting-tab",
                  "data-bs-toggle": "tab",
                  href: "#formatting",
                  role: "tab",
                  "aria-controls": "formatting",
                  "aria-selected": "false"
                }, _hoisted_11, 2)
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", [_ctx.isActiveTab(2)]]),
                  id: "source-order-tab",
                  "data-bs-toggle": "tab",
                  href: "#sourceOrder",
                  role: "tab",
                  "aria-controls": "sourceOrder",
                  "aria-selected": "false"
                }, _hoisted_14, 2)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", [_ctx.isActiveTab(3)]]),
                  id: "shared-settings-tab",
                  "data-bs-toggle": "tab",
                  href: "#sharedSettings",
                  role: "tab",
                  "aria-controls": "sharedSettings",
                  "aria-selected": "false"
                }, _hoisted_17, 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane fade", [_ctx.isActiveContent(0)]]),
                id: "general",
                role: "tabpanel",
                "aria-labelledby": "general-tab"
              }, [
                _createElementVNode("label", null, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "doNotSuggestDataPreference",
                    class: "me-1",
                    checked: !_ctx.SuggestDataPreferenceUpdate
                  }, null, 8, _hoisted_19),
                  _hoisted_20
                ]),
                _hoisted_21,
                _createElementVNode("label", null, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "exportAllComps",
                    class: "me-1",
                    checked: _ctx.ExportAllComps
                  }, null, 8, _hoisted_22),
                  _hoisted_23
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane fade", [_ctx.isActiveContent(1)]]),
                id: "formatting",
                role: "tabpanel",
                "aria-labelledby": "formatting-tab"
              }, [
                _createVNode(_component_PreferredCasing, { preferredCasing: _ctx.PreferredCasing }, {
                  title: _withCtx(() => [
                    _hoisted_24
                  ]),
                  message: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                }, 8, ["preferredCasing"])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane fade", [_ctx.isActiveContent(2)]]),
                id: "sourceOrder",
                role: "tabpanel",
                "aria-labelledby": "source-order-tab"
              }, [
                _createVNode(_component_SourceOrder, {
                  items: this.sourceOrder,
                  isHiddenCheckboxVisible: false,
                  onCallback: _ctx.SourceOrderCallback
                }, {
                  banner: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }, 8, ["items", "onCallback"]),
                _createElementVNode("label", null, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "showDataPreferenceColumn",
                    class: "me-1",
                    checked: _ctx.ShowDataPreferenceColumn
                  }, null, 8, _hoisted_27),
                  _hoisted_28
                ])
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane fade", [_ctx.isActiveContent(3)]]),
                id: "sharedSettings",
                role: "tabpanel",
                "aria-labelledby": "shared-settings-tab"
              }, [
                _hoisted_29,
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", null, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      id: "shareMySettings",
                      class: "me-1",
                      checked: _ctx.ShareMySettings,
                      disabled: _ctx.isShareMySettingsDisabled()
                    }, null, 8, _hoisted_32),
                    _hoisted_33
                  ]),
                  (this.usersUsingMySettings.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.usersUsingMySettings, (item) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: item.passportId,
                            ppid: item.passportId,
                            class: "users-using-my-seetings"
                          }, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 9, _hoisted_35))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_36,
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("select", _hoisted_38, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.getAvailableUserSettings(), (item) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: item.passportId,
                        value: item.passportId,
                        selected: this.isUsingUserSettings(item.passportId)
                      }, _toDisplayString(item.firstName) + " " + _toDisplayString(item.lastName), 9, _hoisted_39))
                    }), 128))
                  ])
                ])
              ], 2)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_ModalFooter, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.SaveGlobalSettings && _ctx.SaveGlobalSettings(...args)))
            }, "Save"),
            _hoisted_40
          ]),
          _: 1
        }),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_Loader, {
              key: 0,
              showLBackDrop: true,
              showLoadingText: true,
              loadingText: "Processing..."
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ], 512))
}